import moment from "moment";

export const addressToString = (address) => {
  return `${address?.addressLine1}, ${
    address?.addressLine2 ? `${address?.addressLine2}, ` : ""
  }${address?.city?.name}, ${address?.state?.name}, ${
    address?.country?.name
  }, ${address?.pincode}`;
};

export const dateToString = (toFormat) => {
  if (!toFormat || !moment(toFormat).isValid()) return "";
  return moment(toFormat).format("DD/MM/YYYY");
};

export const dateTimeToString = (toFormat) => {
  if (!toFormat || !moment(toFormat).isValid()) return "";
  return moment(toFormat).format("DD/MM/YYYY hh:mm:ss A");
};

export const startDateFormatter = (toFormat) => {
  let date = toFormat.toISOString().split("T");
  let finalDate = date[0] + "T00:00:00.000Z";
  return finalDate;
};

export const endDateFormatter = (toFormat) => {
  let date = toFormat.toISOString().split("T");
  let finalDate = date[0] + "T23:59:59.999Z";
  return finalDate;
};
export const addressToStringMultiLine = (address) => {
  return (
    <p>
      {`${address?.addressLine1}, ${
        address?.addressLine2 ? `${address?.addressLine2},` : ""
      } `}
      <br />
      {`${address?.city?.name}, ${address?.state?.name},`}
      <br />
      {`${address?.country?.name}, ${address?.pincode}`}
    </p>
  );
};
